
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { FeatureItem } from "@/types/feature";

export const useFeatureItems = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['feature_items'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('feature_items')
        .select('*')
        .eq('is_enabled', true)
        .order('order_index');
      
      if (error) {
        console.error('Error fetching feature items:', error);
        throw error;
      }
      
      return data as FeatureItem[];
    }
  });

  return {
    data: data || [],
    isLoading,
    error
  };
};
